import React from "react";

import BaseModal from "../BaseModal";
import ring from "../../../assets/ring.jpg?url";

function ViewResultsModal() {
    return (
        <BaseModal
            title={"Will you marry me?"}
            initiallyOpen={false}
            showActionButton={false}
        >
            <div className="text-center text-2xl font-bold py-4">
                <img src={ring} alt="ring" />
                <br />
                Look to your left.
            </div>
        </BaseModal>
    );
}

export default ViewResultsModal;
